import { Link } from '@tiptap/extension-link';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Underline } from '@tiptap/extension-underline';
import { EditorOptions, useEditor } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';
import { DependencyList, useMemo } from 'react';

interface UseRichTextOptions extends Partial<EditorOptions> {
	content?: string;
	editable?: boolean;
	onBlur?: VoidFunction;
	onFocus?: VoidFunction;
	placeholder?: string | null;
}

export const useRichText = ({ placeholder = '', ...rest }: UseRichTextOptions, deps?: DependencyList) => {
	const extensions = useMemo(() => {
		return [
			StarterKit,
			Underline,
			Placeholder.configure({
				placeholder: placeholder || '',
			}),
			Link.configure({
				autolink: true,
				linkOnPaste: true,
				openOnClick: true,
			}),
		];
	}, [placeholder]);

	const editor = useEditor(
		{
			extensions,
			...rest,
		},
		deps
	);

	return {
		html: editor?.getHTML() || '',
		text: editor?.getText() || '',
		editor,
	};
};
